export default "__VITE_ASSET__DPne5S79__"